type Listener = (...args: any[]) => void;
type EventType = string | symbol;

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class EventEmitter {
  // 使用静态属性存储事件和监听器
  private static events: Map<EventType, Listener[]> = new Map();
  private static maxListeners: number = 10;

  static setMaxListeners(n: number): typeof EventEmitter {
    EventEmitter.maxListeners = n;
    return EventEmitter;
  }

  static on(event: EventType, listener: Listener): typeof EventEmitter {
    const listeners = EventEmitter.events.get(event) || [];
    listeners.push(listener);
    EventEmitter.events.set(event, listeners);

    if (listeners.length > EventEmitter.maxListeners) {
      console.warn(`Possible memory leak detected. ${listeners.length} listeners added for event "${String(event)}".`);
    }

    return EventEmitter;
  }

  static emit(event: EventType, ...args: any[]): boolean {
    const listeners = EventEmitter.events.get(event);
    if (listeners) {
      listeners.forEach((listener) => {
        try {
          listener(...args);
        } catch (err) {
          console.error(`Error in listener for event "${String(event)}":`, err);
        }
      });
      return true;
    }
    return false;
  }

  static off(event: EventType, listener?: Listener): typeof EventEmitter {
    if (!listener) {
      EventEmitter.events.delete(event);
      return EventEmitter;
    }

    const listeners = EventEmitter.events.get(event);
    if (listeners) {
      EventEmitter.events.set(
        event,
        listeners.filter((l) => l !== listener),
      );
    }

    return EventEmitter;
  }

  static once(event: EventType, listener: Listener): typeof EventEmitter {
    const onceWrapper: Listener = (...args) => {
      listener(...args);
      EventEmitter.off(event, onceWrapper);
    };
    return EventEmitter.on(event, onceWrapper);
  }

  static listenerCount(event: EventType): number {
    return EventEmitter.events.get(event)?.length || 0;
  }

  static removeAllListeners(): typeof EventEmitter {
    EventEmitter.events.clear();
    return EventEmitter;
  }
}

export default EventEmitter;
